/**
 * Service to handle student-related API requests
 */

/**
 * Fetch students from the API with optional filters
 * @param {Object} filters - Filtering options
 * @returns {Promise<Array>} - Array of student objects
 */
export const fetchStudents = async (filters = {}) => {
    try {
        const token = localStorage.getItem('token');

        // Build query parameters
        const queryParams = new URLSearchParams();
        if (filters.createdToday) queryParams.append('createdToday', 'true');
        if (filters.followUpToday) queryParams.append('followUpToday', 'true');
        if (filters.search) queryParams.append('search', filters.search);
        if (filters.location) queryParams.append('location', filters.location);
        if (filters.branch) queryParams.append('branch', filters.branch);
        if (filters.courseType) queryParams.append('courseType', filters.courseType);
        if (filters.course) queryParams.append('course', filters.course);
        if (filters.enrollment_status) queryParams.append('enrollment_status', filters.enrollment_status);
        if (filters.source) queryParams.append('source', filters.source);


        const response = await fetch(`${process.env.REACT_APP_API_URL}/students?${queryParams.toString()}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error('Failed to fetch students data');
        }

        const data = await response.json();

        // Handle different API response structures
        const studentsArray = Array.isArray(data) ? data :
            (data.students ? data.students :
                (data.data ? data.data : []));

        return studentsArray;
    } catch (error) {
        console.error("Error in fetchStudents service:", error);
        throw error;
    }
};

/**
 * Fetch filter options from API
 * @returns {Promise<Object>} - Object containing filter options
 */
export const fetchFilterOptions = async () => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${process.env.REACT_APP_API_URL}/regdetail`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error('Failed to fetch filter options');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error in fetchFilterOptions service:", error);
        throw error;
    }
};

/**
 * Update a student's information
 * @param {Object} student - Student data to update
 * @returns {Promise<Object>} - Updated student object
 */
export const updateStudent = async (student) => {
    try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${process.env.REACT_APP_API_URL}/students/${student.id}`, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(student)
        });

        if (!response.ok) {
            throw new Error('Failed to update student');
        }

        return await response.json();
    } catch (error) {
        console.error("Error in updateStudent service:", error);
        throw error;
    }
};